import { Box } from "@mui/material"
import { useQuery } from "@tanstack/react-query"
import React from "react"

import { PortfolioAgentsTableRow } from "./PortfolioAgentsTableRow"
import { getPortfolioAgentsRanked, PortfolioAgent } from "@/api/portfolio-agents-api"
import { InMemoryTable } from "@/components/InMemoryTable"
import { LoadingSpinner } from "@/components/LoadingSpinner"

export function PortfolioAgentsTable() {
  const { data: agents } = useQuery({
    queryKey: [`all_portfolio_agents`],
    queryFn: async () => {
      const result = await getPortfolioAgentsRanked()
      console.log("onRankedPortfolioAgents", result)

      return result //.filter((agent) => agent.status !== "Initializing") // TODO
    },
  })

  if (!agents) return <LoadingSpinner />

  return (
    <Box sx={{ background: "var(--mui-palette-paperAlt)" }}>
      <InMemoryTable
        initialSortField="createdAt"
        initialSortDir="desc"
        data={agents}
        headerCells={[
          { label: "Agent Name/ID", sx: { minWidth: 240 } },
          { label: "Tokens", align: "right", sx: { minWidth: 140 } },
          { label: "Net worth", align: "right", sx: { minWidth: 120 } },
          { label: "Total Volume", align: "right", sx: { minWidth: 120 } },
          { label: "24h PnL", align: "right", sx: { minWidth: 160 } },
          { label: "7d PnL", align: "right", sx: { minWidth: 160 } },
          { label: "30d PnL", align: "right", sx: { minWidth: 160 } },
          { label: "All time PnL", align: "right", sx: { minWidth: 160 } },
          // { label: "Rebalancings", align: "right", sx: { minWidth: 160 } },
          // { label: "Created At", align: "right", sx: { minWidth: 160 } },
          { label: "", align: "right", sx: { width: 160 } },
        ]}
        renderRow={(row: PortfolioAgent) => <PortfolioAgentsTableRow key={row.id} row={row} />}
      />
    </Box>
  )
}
